import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_UNIT_RESOURCES_REQUEST = 'FETCH_UNIT_RESOURCES_REQUEST';
export const FETCH_UNIT_RESOURCES_SUCCESS = 'FETCH_UNIT_RESOURCES_SUCCESS';
export const FETCH_UNIT_RESOURCES_FAILURE = 'FETCH_UNIT_RESOURCES_FAILURE';

const method = 'GET';
const buildUnitResourcesUrl = (groupId, unitId) =>
  buildUrl(`/groups/${groupId}/units/${unitId}/app-resources`);

export function fetchUnitResourcesIfNeeded(groupId, unitId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, {
      method,
      url: buildUnitResourcesUrl(groupId, unitId),
    })) {
      return false;
    }

    return dispatch(fetchUnitResources(groupId, unitId));
  };
}

export function fetchUnitResources(groupId, unitId) {
  return (dispatch) => {
    const url = buildUnitResourcesUrl(groupId, unitId);
    const payload = fetch(url);

    return dispatch(fetchUnitResourcesRequest()).payload
      .then((response) => dispatch(fetchUnitResourcesSuccess(response)))
      .catch((error) => {
        if (error.response && error.response.code === 404) {
          return dispatch(fetchUnitResourcesSuccess({ unitId, students: [] }));
        }

        return dispatch(fetchUnitResourcesFailure(error));
      });

    function fetchUnitResourcesRequest() {
      return ApiCall.createAction({
        type: FETCH_UNIT_RESOURCES_REQUEST,
        payload,
        url,
        method,
        groupId,
        unitId,
      });
    }

    function fetchUnitResourcesSuccess(successPayload) {
      return ApiCall.createAction({
        type: FETCH_UNIT_RESOURCES_SUCCESS,
        payload: successPayload,
        url,
        method,
        groupId,
        unitId,
      });
    }

    function fetchUnitResourcesFailure(error) {
      return ApiCall.createAction({
        type: FETCH_UNIT_RESOURCES_FAILURE,
        error,
        url,
        method,
        groupId,
        unitId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/UnitResources/actions.js